/* IvaStyl v42 FINAL size-guide dialogs: no variant/cart handlers are modified. */
(() => {
  const previousFocus = new WeakMap();

  function getDialog(button) {
    const id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : button.closest('variant-picker')?.querySelector('[data-iva-size-dialog]');
  }

  function selectTab(dialog, selected, shouldFocus = true) {
    const key = selected.dataset.ivaSizeTab;
    dialog.querySelectorAll('[data-iva-size-tab]').forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    dialog.querySelectorAll('[data-iva-size-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.ivaSizePanel !== key;
    });
    const scroller = selected.closest('[role="tablist"]');
    if (scroller) scroller.scrollLeft = Math.max(0, selected.offsetLeft - scroller.offsetLeft - (scroller.clientWidth - selected.offsetWidth) / 2);
    if (shouldFocus) selected.focus();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-iva-size-open]');
    if (opener) {
      const dialog = getDialog(opener);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      previousFocus.set(dialog, opener);
      if (!dialog.open) dialog.showModal();
      const active = dialog.querySelector('[data-iva-size-tab][aria-selected="true"]');
      if (active) selectTab(dialog, active, false);
      dialog.querySelector('[data-iva-size-close]')?.focus();
      return;
    }

    const closer = event.target.closest('[data-iva-size-close]');
    if (closer) {
      const dialog = closer.closest('[data-iva-size-dialog]');
      if (dialog?.open) dialog.close();
      return;
    }

    const tab = event.target.closest?.('[data-iva-size-tab]');
    if (tab) {
      const dialog = tab.closest('[data-iva-size-dialog]');
      if (dialog) selectTab(dialog, tab);
      return;
    }

    const dialog = event.target.matches?.('[data-iva-size-dialog]') ? event.target : null;
    if (dialog?.open) {
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest?.('[data-iva-size-tab]');
    if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    const dialog = tab.closest('[data-iva-size-dialog]');
    if (!dialog) return;
    const tabs = [...dialog.querySelectorAll('[data-iva-size-tab]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;
    event.preventDefault();
    selectTab(dialog, tabs[index]);
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-iva-size-dialog]')) return;
    const opener = previousFocus.get(event.target);
    if (opener?.isConnected) opener.focus();
    previousFocus.delete(event.target);
  }, true);
})();
